import React, { useEffect, useRef } from 'react';
import './AulaShell.css';

const NavIndicator = ({ item }) => {
  if (item.live) {
    return <span className="aula-nav-live" title="En vivo" aria-label="En vivo" />;
  }
  if (item.count > 0) {
    return <span className="aula-nav-count">{item.count}</span>;
  }
  return null;
};

export const AulaNav = ({ items, active, onSelect }) => {
  const trackRef = useRef(null);

  useEffect(() => {
    const activeEl = trackRef.current?.querySelector('.aula-nav-item.active');
    if (activeEl?.scrollIntoView) {
      activeEl.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
    }
  }, [active]);

  return (
    <nav className="aula-nav" aria-label="Secciones del aula">
      <div className="aula-nav-track" ref={trackRef}>
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`aula-nav-item ${active === item.key ? 'active' : ''}`}
            aria-current={active === item.key ? 'page' : undefined}
            onClick={() => onSelect(item.key)}
          >
            <i className={`fas ${item.icon}`} aria-hidden="true" />
            <span className="aula-nav-label">{item.label}</span>
            <NavIndicator item={item} />
          </button>
        ))}
      </div>
    </nav>
  );
};

export const AulaOverview = ({ items, onSelect }) => {
  const cards = items.filter((item) => item.key !== 'inicio');
  if (cards.length === 0) return null;

  return (
    <div className="aula-overview">
      {cards.map((item) => (
        <button key={item.key} type="button" className="aula-overview-card" onClick={() => onSelect(item.key)}>
          <span className="aula-overview-icon">
            <i className={`fas ${item.icon}`} aria-hidden="true" />
          </span>
          <span className="aula-overview-copy">
            <strong>{item.label}</strong>
            {item.description && <small>{item.description}</small>}
          </span>
          <span className="aula-overview-foot">
            {item.live ? (
              <span className="aula-live-pill">En vivo</span>
            ) : typeof item.count === 'number' ? (
              <span className="aula-overview-count">{item.count}</span>
            ) : (
              <span />
            )}
            <i className="fas fa-arrow-right" aria-hidden="true" />
          </span>
        </button>
      ))}
    </div>
  );
};

export const AulaSection = ({ active, icon, title, subtitle, status, actions, children }) => (
  <section className="aula-section" hidden={!active}>
    <header className="aula-section-header">
      <span className="aula-section-icon">
        <i className={`fas ${icon}`} aria-hidden="true" />
      </span>
      <div className="aula-section-heading">
        <h2>
          {title}
          {status && <span className="aula-live-pill">{status}</span>}
        </h2>
        {subtitle && <p>{subtitle}</p>}
      </div>
      {actions && <div className="aula-section-actions">{actions}</div>}
    </header>
    <div className="aula-section-body">{children}</div>
  </section>
);

export const AulaEmptyState = ({ icon, children }) => (
  <div className="aula-empty-state">
    <i className={`fas ${icon}`} aria-hidden="true" />
    <p>{children}</p>
  </div>
);
